import { ChevronRight } from '../../assets/icons/chevron right'
import { ChevronLeftIcon } from '../../assets/icons/chevron left'
import {
  DivPag,
  SpanNumQtd,
  SpanNum,
  DivLabel,
  Button,
} from './Pagination.style'

type PaginatioProps = {
  pageNumber: number
  pageSize: number
  offSet: number
  onClick: (page: number) => void
  marginBottom?: string
  label?: string
}

export function Pagination({
  pageNumber,
  pageSize,
  offSet,
  onClick,
  marginBottom,
  label = 'itens',
}: PaginatioProps) {
  const length = Math.ceil(pageSize / offSet)
  const start = Math.max(pageNumber - 5, 1)
  const end = Math.min(pageNumber + 4, length)
  const numPage = Array.from({ length: end - start + 1 }, (_, i) =>
    pageNumber < 10 ? i + 1 : start + i
  )

  const goToPage = (page: number) => {
    onClick(page)
  }
  return (
    <DivPag marginBottom={marginBottom}>
      <SpanNumQtd>
        <div>{pageSize < 7 ? pageSize : offSet}</div>
        <div> de</div>
        <div>{pageSize}</div>
        <div> {label}</div>
      </SpanNumQtd>
      <DivLabel>
        {length > 1 && pageNumber > 1 && (
          <Button type="button" onClick={() => goToPage(pageNumber - 1)}>
            <ChevronLeftIcon />
          </Button>
        )}
        {numPage.map(num => (
          <SpanNum
            key={num}
            checkNum={num === pageNumber}
            onClick={() => goToPage(num)}
          >
            {num}
          </SpanNum>
        ))}
        {length > 1 && pageNumber < length && (
          <Button type="button" onClick={() => goToPage(pageNumber + 1)}>
            <ChevronRight />
          </Button>
        )}
      </DivLabel>
    </DivPag>
  )
}

export function PaginationHistoryPredict({
  pageNumber,
  pageSize,
  offSet,
  onClick,
  marginBottom,
  label = 'itens',
}: PaginatioProps) {
  const length = Math.ceil(pageSize / offSet)
  const start = Math.max(pageNumber - 3, 1)
  const end = Math.min(pageNumber + 1, length)
  const numPage = Array.from({ length: end - start + 1 }, (_, i) =>
    pageNumber < 4 ? i + 1 : start + i
  )

  const goToPage = (page: number) => {
    onClick(page)
  }
  return (
    <DivPag marginBottom={marginBottom}>
      <SpanNumQtd>
        <div>{pageSize < 7 ? pageSize : offSet}</div>
        <div> de</div>
        <div>{pageSize}</div>
        <div> {label}</div>
      </SpanNumQtd>
      <DivLabel>
        {length > 1 && pageNumber > 1 && (
          <Button type="button" onClick={() => goToPage(pageNumber - 1)}>
            <ChevronLeftIcon />
          </Button>
        )}
        {numPage.map(num => (
          <SpanNum
            key={num}
            checkNum={num === pageNumber}
            onClick={() => goToPage(num)}
          >
            {num}
          </SpanNum>
        ))}
        {length > 1 && pageNumber < length && (
          <Button type="button" onClick={() => goToPage(pageNumber + 1)}>
            <ChevronRight />
          </Button>
        )}
      </DivLabel>
    </DivPag>
  )
}
